import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/index.css";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Tasks from "@/pages/Tasks";
import GED from "@/pages/GED";
import FormEditor from "@/pages/FormEditor";
import Forms from "@/pages/Forms";
import AIAssistant from "@/pages/AIAssistant";
import Users from "@/pages/Users";
import Logistics from "@/pages/Logistics";
import FieldCapture from "@/pages/FieldCapture";
import CalendarSync from "@/pages/CalendarSync";
import Configuration from "@/pages/Configuration";
import Profile from "@/pages/Profile";
import Roles from "@/pages/Roles";

const Wrap = ({ children, roles }) => (
  <ProtectedRoute roles={roles}><Layout>{children}</Layout></ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Wrap><Dashboard /></Wrap>} />
          <Route path="/projects" element={<Wrap><Projects /></Wrap>} />
          <Route path="/projects/:id" element={<Wrap><ProjectDetail /></Wrap>} />
          <Route path="/tasks" element={<Wrap roles={["admin","chef_projet","expert"]}><Tasks /></Wrap>} />
          <Route path="/ged" element={<Wrap><GED /></Wrap>} />
          <Route path="/logistique" element={<Wrap roles={["admin","chef_projet","expert"]}><Logistics /></Wrap>} />
          <Route path="/terrain" element={<Wrap roles={["admin","chef_projet","expert"]}><FieldCapture /></Wrap>} />
          <Route path="/calendrier" element={<Wrap><CalendarSync /></Wrap>} />
          <Route path="/forms" element={<Wrap roles={["admin","chef_projet","expert"]}><Forms /></Wrap>} />
          <Route path="/forms/:id" element={<Wrap roles={["admin","chef_projet","expert"]}><FormEditor /></Wrap>} />
          <Route path="/ai" element={<Wrap roles={["admin","chef_projet"]}><AIAssistant /></Wrap>} />
          <Route path="/users" element={<Wrap roles={["super_admin","admin"]}><Users /></Wrap>} />
          <Route path="/configuration" element={<Wrap roles={["super_admin"]}><Configuration /></Wrap>} />
          <Route path="/roles" element={<Wrap roles={["super_admin"]}><Roles /></Wrap>} />
          <Route path="/profile" element={<Wrap><Profile /></Wrap>} />
          <Route path="/users/:id/profile" element={<Wrap><Profile /></Wrap>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
